import * as React from 'react';
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography';
import LogoB from '../Logos/LogoB'
import Stack from '@mui/material/Stack'
import Dialog from '../Dialog'
import Portfolios from '../Portfolios'
import useMediaQuery from '@mui/material/useMediaQuery';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const AboutShare = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return(
    <Stack sx={{height: isMobile?'310px':'260px', overflow: 'scroll', paddingTop: '20px'}} spacing={2}>
    <Typography variant='body1' color='default'>
    Welcome to a collection of Swiss property projects, backed by Bldrs.ai.
    Feel free to explore by selecting a project on the map or browsing through the 'Projects' section.
     Each one includes a 3D model—just click on the cube icon to view it.
    </Typography>
    <Stack sx={{height: isMobile?'310px':'260px', overflow: 'scroll', paddingTop: '20px'}} spacing={0}>
    <Link href="https://www.swiss-property.ch/en/">  www.swiss-property.ch</Link>
    <Link href="https://www.bldrs.ai">  www.bldrs.ai</Link>
    </Stack>
  </Stack>
  )
}



const RightSide = () => {
  return(
    <Stack
    direction="row"
    alignItems="center"
    spacing={0}
    sx={{marginRight:'-15px'}}
    >
          <Dialog
            iconButton={true }
            labelBold={false}
            buttonLabel='SP Portfolio'
            tabs={false}
            tabList={['Info']}
            icon={<InfoOutlinedIcon size='inherit' color='primary'/>}
            dialogTitle={
            <Stack
            alignItems={'center'}
            justifyContent={'center'}
            direction='row'
            spacing={1}
            >
                <Typography variant={'body1'} color='primary'>
                SP Portfolio
                </Typography>
              </Stack>
            }
            dialogContent={
              <AboutShare/>
            }
          />
      <Dialog
        actionTitle={'OK'}
        icon={<LogoB scale={1.3}/>}
        buttonColor={'primary'}
        iconButton={true}
        tabs={false}
        tabList={['Recent']}
        dialogTitle={
          <Typography>
            Bldrs.ai
          </Typography>
        }
        dialogContent={
          <Stack sx={{ overflow: 'scroll', paddingTop: '20px'}} spacing={0}>
            <Typography>
            Bldrs.ai is bringing modern IT workflows to the Architecture and Engineering industries.
          </Typography>
          <Link href="https:/bldrs.ai" sx={{marginTop:'20px'}}> Bldrs: Share</Link>
        </Stack>
        }
      />
    </Stack>
  )

}

export default RightSide
